<template>
  <div
    class="zeus-content"
  >

    <page
      v-for="page in pageList"
      :key="page.id"
      :data="page"
    />

  </div>

</template>

<script>
import Page from './page'

export default {
  components: { Page },
  props: {
    pageData: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    pageList() {
      const list = []
      const hitUserGroup = this.$root.activeData.hitUserGroup
      this.pageData.forEach(page => {
        if (!page.type) {
          list.push(page)
        } else if (page.children) {
          list.push(this.currentPage(page.children), hitUserGroup)
        }
      })
      return list
    }
  },
  methods: {
    currentPage(data, hitUserGroup) {
      if (this.$root.activeData.sceneCode && hitUserGroup?.length > 0) {
        for (let i = 0; i < data.length; i++) {
          const { activeList } = data[i].options?.basic?.showPage?.melete
          const commonElements = activeList.filter(item => hitUserGroup.includes(item))
          if (commonElements.length > 0) return data[i]
        }
      }
      return data[data.length - 1]
    }
  }
}
</script>
